// Use the official Gravity Forms hook instead of window.load
jQuery(document).on('gform_post_render', function() {
    if (typeof gform !== 'undefined' && typeof gform.addFilter === 'function') {

        gform.addFilter('gform_file_upload_markup', function (html, file, up, strings, imagesUrl) {
            // Safely fetch parameters with fallbacks to prevent undefined errors
            const params = up && up.settings && up.settings.multipart_params ? up.settings.multipart_params : {};
            const formId = params.form_id || 0;
            const fieldId = params.field_id || 0;

            // Generate clean, modern markup using template literals
            html = `<strong>${file.name}</strong>` + `<button type="button" class="gform_delete button bg--primary" onclick="gformDeleteUploadedFile(${formId}, ${fieldId}, this);">Remove</button>`;

            return html;
        });

    }
});
